/* 화면 매니페스트 — 데모 상단 네비게이터 드롭다운 + 사이드바 + 모바일 탭바가
 * 모두 이 파일 하나를 참조해 일관성을 유지한다. */

export interface RouteMeta {
    group: 'WEB' | 'MOBILE';
    key: string;
    ico: string;
    riIco: string;
    title: string;
    path: string;
    bc: string[];
}

export const DEMO2_MANIFEST: RouteMeta[] = [
    { group: 'WEB', key: 'login', ico: '🔐', riIco: 'ri-lock-line', title: '로그인', path: '/demo2/web/login', bc: ['홈', '로그인'] },
    { group: 'WEB', key: 'dashboard', ico: '🗺️', riIco: 'ri-dashboard-3-line', title: '메인 대시보드', path: '/demo2/web/dashboard', bc: ['홈', '대시보드'] },
    { group: 'WEB', key: 'map', ico: '📍', riIco: 'ri-map-pin-line', title: '수목 지도', path: '/demo2/web/map', bc: ['홈', '수목 관리', '지도'] },
    { group: 'WEB', key: 'tree-list', ico: '🌳', riIco: 'ri-tree-line', title: '수목 목록', path: '/demo2/web/tree-list', bc: ['홈', '수목 관리', '목록'] },
    { group: 'WEB', key: 'tree-detail', ico: '🔍', riIco: 'ri-search-eye-line', title: '수목 상세', path: '/demo2/web/tree-detail/TR-1001', bc: ['홈', '수목 관리', '상세'] },
    { group: 'WEB', key: 'moisture', ico: '💧', riIco: 'ri-drop-line', title: '수분 모니터링', path: '/demo2/web/moisture', bc: ['홈', '수목 관리', '수분 모니터링'] },
    { group: 'WEB', key: 'alerts', ico: '🚨', riIco: 'ri-alarm-warning-line', title: '알림·경고 센터', path: '/demo2/web/alerts', bc: ['홈', '현장 작업', '알림 센터'] },
    { group: 'WEB', key: 'work-management', ico: '📋', riIco: 'ri-file-list-3-line', title: '작업 관리', path: '/demo2/web/work-management', bc: ['홈', '현장 작업', '작업 관리'] },
    { group: 'WEB', key: 'work-history', ico: '🗂️', riIco: 'ri-history-line', title: '작업 이력', path: '/demo2/web/work-history', bc: ['홈', '현장 작업', '작업 이력'] },
    { group: 'WEB', key: 'reports', ico: '📊', riIco: 'ri-bar-chart-box-line', title: '리포트·분석', path: '/demo2/web/reports', bc: ['홈', '분석', '리포트'] },
    { group: 'WEB', key: 'settings', ico: '⚙️', riIco: 'ri-settings-3-line', title: '설정', path: '/demo2/web/settings', bc: ['홈', '시스템', '설정'] },
    { group: 'MOBILE', key: 'm-login', ico: '🔐', riIco: 'ri-lock-line', title: '로그인', path: '/demo2/mobile/login', bc: ['홈', '로그인'] },
    { group: 'MOBILE', key: 'm-home', ico: '🏠', riIco: 'ri-home-4-line', title: '홈', path: '/demo2/mobile/home', bc: ['홈'] },
    { group: 'MOBILE', key: 'm-worklist', ico: '📋', riIco: 'ri-file-list-3-line', title: '작업 목록', path: '/demo2/mobile/worklist', bc: ['홈', '작업 목록'] },
    { group: 'MOBILE', key: 'm-work-process', ico: '✅', riIco: 'ri-checkbox-circle-line', title: '작업 처리', path: '/demo2/mobile/work-process/WO-3050', bc: ['홈', '작업 처리'] },
    { group: 'MOBILE', key: 'm-map', ico: '📍', riIco: 'ri-map-pin-line', title: '지도', path: '/demo2/mobile/map', bc: ['홈', '지도'] },
    { group: 'MOBILE', key: 'm-moisture', ico: '💧', riIco: 'ri-drop-line', title: '수분 상태 확인', path: '/demo2/mobile/moisture', bc: ['홈', '수분 상태 확인'] },
    { group: 'MOBILE', key: 'm-history', ico: '🗂️', riIco: 'ri-history-line', title: '내 작업 이력', path: '/demo2/mobile/history', bc: ['홈', '내 작업 이력'] },
];

export const WEB_SIDEBAR_SECTIONS: { label: string; items: { key: string; ico: string; riIco: string; txt: string; path: string; pillFromAlerts?: boolean }[] }[] = [
    { label: '메인', items: [{ key: 'dashboard', ico: '🗺️', riIco: 'ri-dashboard-3-line', txt: '대시보드', path: '/demo2/web/dashboard' }] },
    { label: '수목 관리', items: [
        { key: 'map', ico: '📍', riIco: 'ri-map-pin-line', txt: '수목 지도', path: '/demo2/web/map' },
        { key: 'tree-list', ico: '🌳', riIco: 'ri-tree-line', txt: '수목 목록', path: '/demo2/web/tree-list' },
        { key: 'moisture', ico: '💧', riIco: 'ri-drop-line', txt: '수분 모니터링', path: '/demo2/web/moisture' },
    ] },
    { label: '현장 작업', items: [
        { key: 'alerts', ico: '🚨', riIco: 'ri-alarm-warning-line', txt: '알림·경고 센터', path: '/demo2/web/alerts', pillFromAlerts: true },
        { key: 'work-management', ico: '📋', riIco: 'ri-file-list-3-line', txt: '작업 관리', path: '/demo2/web/work-management' },
        { key: 'work-history', ico: '🗂️', riIco: 'ri-history-line', txt: '작업 이력', path: '/demo2/web/work-history' },
    ] },
    { label: '분석 · 시스템', items: [
        { key: 'reports', ico: '📊', riIco: 'ri-bar-chart-box-line', txt: '리포트·분석', path: '/demo2/web/reports' },
        { key: 'settings', ico: '⚙️', riIco: 'ri-settings-3-line', txt: '설정', path: '/demo2/web/settings' },
    ] },
];

export const MOBILE_TABS: { key: string; ico: string; riIco: string; txt: string; path: string }[] = [
    { key: 'm-home', ico: '🏠', riIco: 'ri-home-4-line', txt: '홈', path: '/demo2/mobile/home' },
    { key: 'm-worklist', ico: '📋', riIco: 'ri-file-list-3-line', txt: '작업', path: '/demo2/mobile/worklist' },
    { key: 'm-map', ico: '📍', riIco: 'ri-map-pin-line', txt: '지도', path: '/demo2/mobile/map' },
    { key: 'm-moisture', ico: '💧', riIco: 'ri-drop-line', txt: '수분', path: '/demo2/mobile/moisture' },
    { key: 'm-history', ico: '🗂️', riIco: 'ri-history-line', txt: '이력', path: '/demo2/mobile/history' },
];

export const WEB_PAGE_META: Record<string, { title: string; bc: string[] }> = Object.fromEntries(
    DEMO2_MANIFEST.filter(m => m.group === 'WEB').map(m => [m.key, { title: m.title, bc: m.bc }]),
);
